import React, { useEffect, useState } from "react";
import RangeSliderWrapper from "./rangeSliderWrapper";
import RangeSliderCircleRealValue from "./rangeSliderCircleRealValue";

interface RangeDoubleSliderProps {
    defaultLeft: number;
    defaultRight: number;
    min: number;
    max: number;
    step: number;
    onUpdateLeft: (value: number) => void;
    onUpdateRight: (value: number) => void;
    title: string;
    offset: number;
    checkTitle?: (value: number) => string | undefined;

}

export default function RangeDoubleSlider(props: RangeDoubleSliderProps) {

    const [valueLeft, setValueLeft] = useState(props.defaultLeft);
    const [valueRight, setValueRight] = useState(props.defaultRight);

    useEffect(() => {
        setValueLeft(props.defaultLeft);
        setValueRight(props.defaultRight);
    }, [props.defaultLeft, props.defaultRight]);

    const range = props.max-props.min;
    return <RangeSliderWrapper checkTitle={props.checkTitle} title={props.title} values={{
        value1: valueLeft,
        value2: valueRight
    }}>
        <RangeSliderCircleRealValue maxPos={valueRight-props.offset} default={props.defaultLeft} min={props.min} max={props.max} step={props.step} onUpdate={(newValue: number) => {
                if(newValue != valueLeft) {
                    setValueLeft(newValue);
                    props.onUpdateLeft(newValue);
                }
            }}/>
        <RangeSliderCircleRealValue minPos={valueLeft+props.offset} default={props.defaultRight} min={props.min} max={props.max} step={props.step} onUpdate={(newValue: number) => {
            if(newValue != valueRight) {
                setValueRight(newValue);
                props.onUpdateRight(newValue);
            }
        }}/>
    </RangeSliderWrapper>;

}